import { Grid2 as Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		userSelect: "none",
		height: "40px",
	},
});

interface Props {
	assetName: number;
	assetId: number;
	heatStatus: string;
}
const heatStatuses: { [key: string]: any } = {
	S: { name: "Scheduled", color: " #0288D1", letter: "S" },
	M: { name: "Melting", color: " #FF7043", letter: "M" },
	T: { name: "Tapped", color: " #D2AF00", letter: "T" },
	O: { name: "Opened", color: " #43A047", letter: "O" },
	C: { name: "Closed", color: " #607D8B", letter: "C" },
	R: { name: "Returned", color: " #8D6E63", letter: "R" },
	F: { name: "Finished", color: " #3F90B5", letter: "F" },
};

export const AssetTitle = ({ assetId, assetName, heatStatus }: Props) => {
	const classes = useStyles();
	const defaultColor = "#D6D6D6";
	const colors: { [assetId: number]: string } = {
		11: "#dae8fc",
		12: "#d5e8d4",
	};
	const value = heatStatuses[heatStatus];

	return (
		<>
			<Grid container spacing={1}>
				<Grid size={{ xs: 12, md: 12 }}>
					<Card
						className={classes.root}
						style={{
							backgroundColor: colors[assetId],
						}}
						variant="outlined"
					>
						<CardContent>
							<Typography>{assetName}</Typography>
						</CardContent>
					</Card>
				</Grid>
				{heatStatus && (
					<Grid size={{ xs: 12, md: 12 }}>
						<div
							style={{
								backgroundColor: value?.color || defaultColor,
								color: "#fff",
								borderRadius: "4px",
								padding: `4px`,
								textAlign: "center",
							}}
						>
							<Typography>{value?.name}</Typography>
						</div>
					</Grid>
				)}
			</Grid>
		</>
	);
};
